import React from "react";
import Message from "carbon-react/lib/components/message";

import "./Message.css";

const SuccessMessage = (props) => {
  const dismissVisible =
    props.onDismiss && typeof props.onDismiss === "function";

  const defaultClassName = "message-banner";
  const className =
    props.className && props.className.length > 0
      ? `${defaultClassName} ${props.className}`
      : defaultClassName;

  return (
    <Message
      className={className}
      as="success"
      border
      id={props.id || "infoMessageId"}
      open
      roundedCorners
      {...(dismissVisible
        ? {
            onDismiss: () => {
              props.onDismiss();
            },
          }
        : {})}
      {...(dismissVisible ? { showCloseIcon: true } : {})}
    >
      {props.message}
    </Message>
  );
};

export default SuccessMessage;
